import { CoreBox, CoreTypography } from '@youscience/core';

import { RADIUS, LINE_WIDTH } from '@constants/chart';

import { separateDigitsByComma } from '@utils/formatter';

import { sxStyles, StyledCircle, StyledCutOut, StyledPoint, StyledLine } from './Chart.styles';

type ChartProps = {
  value: number;
  min: number;
  max: number;
};

const MIN_PERCENTAGE_VALUE = 15;

export const Chart = ({ value, min, max }: ChartProps) => {
  const percentage = value > min ? ((value - min) * 100) / (max - min) : min;
  const minPercentage = percentage < MIN_PERCENTAGE_VALUE ? MIN_PERCENTAGE_VALUE : percentage;

  const degreeangle = ((100 - minPercentage) * 180) / 100;
  const thetaangle = (degreeangle * Math.PI) / 180;
  let x = RADIUS * Math.cos(thetaangle);
  let y = RADIUS - RADIUS * Math.sin(thetaangle);

  if (x > 0) {
    x += RADIUS;
    x = x - LINE_WIDTH / 2 - 4;
  } else {
    x *= -1;
    x = RADIUS - x;
    x = x + LINE_WIDTH / 2 - 4;
  }
  if ((degreeangle >= 0 && degreeangle < 2) || (degreeangle <= 180 && degreeangle > 178)) {
    y -= 8;
  }

  return (
    <CoreBox sx={sxStyles.wrapper}>
      <CoreBox sx={sxStyles.container}>
        <StyledCircle percentage={minPercentage} />

        <StyledCutOut />

        <StyledPoint xcoordinate={x} ycoordinate={y} />

        <CoreBox component="span" sx={sxStyles.data}>
          <CoreTypography variant="h4" component="h3">
            {separateDigitsByComma.format(value)}
          </CoreTypography>
        </CoreBox>

        <CoreBox component="span" sx={sxStyles.start}>
          <CoreTypography variant="caption">{separateDigitsByComma.format(min)}</CoreTypography>
        </CoreBox>

        <CoreBox component="span" sx={sxStyles.end}>
          <CoreTypography variant="caption">{separateDigitsByComma.format(max)}</CoreTypography>
        </CoreBox>

        <StyledLine />
      </CoreBox>
    </CoreBox>
  );
};
